import { api } from '@/api/client';
export async function fetchAddressSuggestions(q, count = 5) {
    const { data } = await api.get('/v1/public/address-suggestions', {
        params: { q, count },
    });
    return data;
}
export async function fetchAppCapabilities() {
    const { data } = await api.get('/v1/public/app-capabilities');
    return data;
}
